// Generated by scripts/generate-icons.ts
/* eslint-disable */

// This file is auto-generated. Do not edit manually.
import React from 'react';
import { BaseIcon } from '../src/components/BaseIcon';
import type { IconDefinition, IconPath } from '../src/types/IconData.types';

const iconData: IconDefinition = {
  name: "Rotate",
  viewBox: "0 0 20 20",
  paths: [
    {
      d: "M15.329 11.123a.35.35 0 0 1 .237.427C14.9 14.154 12.625 16 9.998 16 7.8 16 5.843 14.71 4.873 12.747l-.21 2.281-.01.063a.345.345 0 0 1-.352.262.337.337 0 0 1-.3-.376l.307-3.354.013-.067c.055-.194.257-.31.443-.236l2.962 1.176.054.027a.356.356 0 0 1 .133.425l-.027.057a.33.33 0 0 1-.407.15l-2.053-.816c.841 1.784 2.598 2.964 4.572 2.964 2.321 0 4.332-1.632 4.92-3.933a.34.34 0 0 1 .351-.258zM10.002 4c2.196 0 4.153 1.29 5.124 3.252l.21-2.28.01-.063a.345.345 0 0 1 .353-.261.337.337 0 0 1 .3.376l-.308 3.353-.012.067c-.055.194-.258.31-.443.236l-2.963-1.176-.053-.027a.355.355 0 0 1-.133-.424l.027-.058a.33.33 0 0 1 .406-.15l2.053.815c-.842-1.783-2.597-2.963-4.571-2.963C7.68 4.697 5.67 6.33 5.08 8.63a.34.34 0 0 1-.35.258l-.06-.011a.35.35 0 0 1-.238-.427C5.1 5.846 7.375 4 10.002 4"
    }
  ]
};

export const RotateIcon: React.FC<React.SVGProps<SVGSVGElement> & { iconPathClassName?: string }> = (props) => {
  return <BaseIcon icon={iconData} {...props} />;
};
